package com.solevo.dist.repository.implementation.statements

import com.solevo.dist.application.models.Invoice
import com.solevo.dist.application.models.Product
import com.solevo.dist.application.models.Transaction
import com.solevo.dist.network.api.invoice.InvoiceRemoteSource
import com.solevo.dist.network.api.products.ProductRemoteSource
import com.solevo.dist.network.api.transactions.TransactionRemoteSource
import com.solevo.dist.repository.ApplicationStatementRepository
import kotlinx.coroutines.flow.Flow

class StatementRepository(
    private val transactionRemoteSource: TransactionRemoteSource,
    private val invoiceRemoteSource: InvoiceRemoteSource,
    private val productRemoteSource: ProductRemoteSource
): ApplicationStatementRepository {
    override fun getTransactionsLive(): Flow<List<Transaction>> {
        return transactionRemoteSource.getTransactionsLive()
    }

    override fun getTransactionByInvoiceIdLive(invoiceId: String): Flow<Transaction> {
        return transactionRemoteSource.getTransactionByInvoiceIdLive(invoiceId)
    }

    override fun getInvoice(id: String): Flow<Invoice?> {
        return invoiceRemoteSource.getInvoice(id)
    }

    override fun getTransaction(id: String): Flow<Transaction?> {
        return transactionRemoteSource.getTransaction(id)
    }

    override fun getProducts(ids: List<String>): Flow<List<Product>> {
        return productRemoteSource.getProducts(ids)
    }

    override fun getInvoicesForOrderLive(orderId: String): Flow<List<Invoice>> {
        return invoiceRemoteSource.getInvoicesForOrderLive(orderId)
    }
}
